import { Fragment} from 'react'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

export default props => {

  const { id, className, mode, size, variant='primary' } = props

  const authorised = useSelector(state => {
    const { user } = state
    return  (user && user.administrator && user.administrator.entities && Array.isArray(user.administrator.entities) && user.administrator.entities.length)
  })

  const history = useHistory()

  if(!authorised){
    return null
  }

  const label = id === 'new' ? 'Add a venue' : 'Edit'
  const icon = id === 'new' ? faPlus : faEdit

  const  handleClick = (e) => {
    history.push('/venues/' + id + '/edit')
  }

  if(mode === 'icon'){
    return (
      <Fragment>
        <button title={label} onClick={handleClick} className={className}>
          <FontAwesomeIcon icon={icon} />
        </button>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Button variant={variant} title={label} onClick={handleClick} className={className} size={size}>
        <FontAwesomeIcon icon={icon} className="d-inline d-md-none" /><span className="d-none d-md-inline text-nowrap">{label}</span>
      </Button>
    </Fragment>
  )
}